<template>
  <div>
    <input type="text" className="form-control" placeholder="" v-model="propsValue">

    <div class="row">
      <div class="col"><button class="btn btn-primary btnMenu" >基本資料</button></div>
    </div>
    <div class="row">
      <div class="col">
        <button class="btn btn-primary btnMenu" @click="goto('DepUrology')">泌尿科</button>
      </div>
      <div class="col">
        <button class="btn btn-primary btnMenu" @click="goto('DepNeurosurgery')">神經外科</button>
      </div>
      <div class="col">
        <button class="btn btn-primary btnMenu" @click="goto('DepOrthopedics')">骨科</button>
      </div>
      <div class="col">
        <button class="btn btn-primary btnMenu" @click="goto('DepRehabiltation')">復健科</button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button class="btn btn-primary btnMenu" @click="goto('DepTraditionalChineseMedicine')">中醫科</button>
      </div>
      <div class="col">
        <button class="btn btn-primary btnMenu" @click="goto('DepDental')">牙科</button>
      </div>
      <div class="col">
        <button class="btn btn-primary btnMenu" @click="goto('DepPlasticSurgery')">整形外科</button>
      </div>
      <div class="col">

      </div>
    </div>

  </div>
</template>

<script>
/**

 **/


export default {
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      propsValue: this.value,
      formData: {
        name: "",
      },
    };
  },
  watch: {
    propsValue(newVal) {
      //this.('input', newVal);
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.propsValue = newVal
    }
  },
  methods: {
    //給予value屬性預設值
    initValue() {
      const isMyObjectEmpty = !Object.keys(this.value).length;

      if (isMyObjectEmpty) {
        let template = {...this.datasDemo};
        this.value = template;
      }
    },
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    goto(dep){
      this.$router.push({ name: 'RCCIndexFreeClinic', query: { dep: dep }})
    }
  },
  mounted() {
    // this.initValue()
    //this.loadData()
  },
}
</script>

<style scoped>
.btnMenu{

}
</style>
